// One-time "open event management" links created from the admin EVENTS dashboard.
export const ADMIN_EVENT_ACCESS_URL = process.env.REACT_APP_ADMIN_EVENT_ACCESS_URL
  || "https://us-central1-invitations778.cloudfunctions.net/exchangeAdminEventAccess";

export const exchangeAdminEventAccess = async (token) => {
  const response = await fetch(ADMIN_EVENT_ACCESS_URL, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.code || "ADMIN_ACCESS_FAILED");
    error.code = result.code || `HTTP_${response.status}`;
    throw error;
  }
  return result;
};
